module.exports = __webpack_public_path__ + "img/ShowtimwAngel.3a543032.jpg";